import { Theme } from "@mui/system";

export const validateEmail = (value: string | undefined, shouldCheckForAdmin?: boolean): boolean => {
    if (!value)
        return false;

    if (shouldCheckForAdmin && value.toLowerCase() === 'admin')
        return true;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
};

export const getPasswordStrength = (password: string, theme: Theme) => {
    let score = 0;
    if (password.length >= 6) score++;
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    if (score < 2) return { label: 'Weak', color: theme.palette.error.main };
    if (score < 4) return { label: 'Fair', color: theme.palette.warning.main };
    if (score < 6) return { label: 'Good', color: theme.palette.secondary.main };
    return { label: 'Strong', color: theme.palette.success.main };
};